import { Error } from '@clearkit/icons';
import { CKBox, CKLayoutHorizontal } from 'clearkit';

import { PageLayout } from '~/components/unified/PageLayout';

export function FetchErrorRetry() {
  return (
    <PageLayout.Content className="text-center space-y-6">
      <CKLayoutHorizontal justifyContent="center">
        <CKBox className="p-2">
          <Error className="w-8 h-8 fill-gradient-br-red" />
        </CKBox>
      </CKLayoutHorizontal>
      <div>
        <h1 className="mb-2 text-lg font-medium">
          There was a problem getting prospector data
        </h1>
        <p>Try refreshing the page</p>
      </div>
    </PageLayout.Content>
  );
}
